/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Filter cases by asset type
 * @export
 */
export const ControlAssetType = {
    User: 'USER',
    Process: 'PROCESS',
    UserAgent: 'USER_AGENT',
    File: 'FILE',
    Endpoint: 'ENDPOINT',
    Location: 'LOCATION',
    Ip: 'IP',
    Domain: 'DOMAIN'
} as const;
export type ControlAssetType = typeof ControlAssetType[keyof typeof ControlAssetType];


export function ControlAssetTypeFromJSON(json: any): ControlAssetType {
    return ControlAssetTypeFromJSONTyped(json, false);
}

export function ControlAssetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAssetType {
    return json as ControlAssetType;
}

export function ControlAssetTypeToJSON(value?: ControlAssetType | null): any {
    return value as any;
}

